import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
const links = [{
  label: 'Servicios',
  id: 'services'
}, {
  label: 'Uñas',
  id: 'nails-gallery'
}, {
  label: 'Cejas',
  id: 'brows-gallery'
}, {
  label: 'Cabello',
  id: 'hair-gallery'
}, {
  label: 'Opiniones',
  id: 'testimonials'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
    setOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-md' : 'bg-white/80 backdrop-blur'}`} data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16 md:h-20" data-id="element-124">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold rounded-full" aria-label="Ir al inicio" data-id="element-125">
          <Logo size="small" data-id="element-126" />
          <span className="font-serif font-bold text-charcoal text-lg hidden sm:inline" data-id="element-127">
            VR Beauty Studio
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8" data-id="element-128">
          {links.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-charcoal/80 font-medium hover:text-gold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-gold rounded px-1" data-id="element-129">
              {link.label}
            </button>)}
          <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors shadow-md" data-id="element-130">
            Reservar turno
          </a>
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden text-charcoal p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold rounded" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} data-id="element-131">
          {open ? <X className="w-6 h-6" data-id="element-132" /> : <Menu className="w-6 h-6" data-id="element-133" />}
        </button>
      </div>

      {open && <div className="md:hidden bg-white border-t border-pink/30 shadow-lg" data-id="element-134">
          <div className="flex flex-col px-4 py-4 gap-2" data-id="element-135">
            {links.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-left py-3 text-charcoal/80 font-medium hover:text-gold transition-colors" data-id="element-136">
                {link.label}
              </button>)}
            <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="mt-2 px-6 py-3 bg-gold text-white font-semibold rounded-full text-center hover:bg-gold/90 transition-colors" data-id="element-137">
              Reservar turno
            </a>
          </div>
        </div>}
    </nav>;
}